import React from "react"
import autobind from "class-autobind"
import { Card, CardHeader, CardActions, RaisedButton, CardText } from "material-ui"
import WorkflowStore from "../../stores/WorkflowStore"
import { IWorkflow } from "../../models"
import WorkflowDescription from "./WorkflowDescription"
import WorkflowProgress from "./WorkflowProgress"

interface IProps {
    workflow: IWorkflow
}

interface IState {
}

export default class WorkflowCard extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    render() {
        const avitarUrl = this.props.workflow.CompletedStepCount === this.props.workflow.TotalStepCount ?
            "https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/icon-assets/check-avitar.svg" :
            "https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/icon-assets/working-avitar.svg"

        const workflowButtonText = this.props.workflow.CompletedStepCount === 0 ? this.props.workflow.LaunchButtonStartText :
            (this.props.workflow.CompletedStepCount >= this.props.workflow.TotalStepCount ? this.props.workflow.LaunchButtonFinishedText : this.props.workflow.LaunchButtonContinueText)

        return (
            <Card>
                <CardHeader
                    title={this.props.workflow.Name}
                    subtitle={this.props.workflow.SubTitle}
                    actAsExpander={true}
                    showExpandableButton={true}
                    avatar={avitarUrl}
                />
                <CardActions>
                    <div style={{ margin: 20 }}>
                        <div style={{ marginTop: 10, marginBottom: 30 }}>
                            <WorkflowProgress workflow={this.props.workflow} />
                        </div>
                        <RaisedButton
                            data-intercom-target={"Workflow-Btn-OpenWorkflow"}
                            label={workflowButtonText}
                            secondary={true}
                            onTouchTap={() => WorkflowStore.setShowWorkflowDrawer(true)}
                        />
                    </div>
                </CardActions>
                <CardText expandable={true}>
                    <WorkflowDescription workflow={this.props.workflow} />
                </CardText>
            </Card>
        )
    }
}